<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="'857px'"
      show-close
      @close="close"
      append-to-body
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :amzSkuCode="amzSkuCode"
          :disabled="disabled"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 20px 0;
}

::v-deep .el-drawer__body {
  flex: 1;
  overflow: auto;
}
</style>
